document.addEventListener("DOMContentLoaded", function () {
  const sectionId = document.querySelector(".product-page")?.id;
  if (sectionId) {
    window.initAccordionSection(sectionId);
  }

  const productData = window.productData;
  const productMedias = document.querySelectorAll(".main-media-wrapper");

  if (productMedias.length > 1) {
    const isMobile = window.innerWidth <= 999;
    const mediasSlider = document.querySelector(".main-media-container");
    const sliderBtns = document.querySelector(".slider-container .slider-btns");
    const prevArrow = document.querySelector(".slider-container .prev");
    const nextArrow = document.querySelector(".slider-container .next");
    const sliderBullets = document.querySelectorAll(".slider-bullet");
    const slider = document.querySelector(".gallery-main");

    const mediaGap = 15;
    const DRAG_THRESHOLD = isMobile ? 50 : 150; // Minimum pixels to drag before changing slides
    const FADE_DELAY = 50; // Delay for fade effects in milliseconds
    const TRANSITION_DURATION = 300;
    let currentSlideIndex = 0;
    let mediaLength = productMedias.length;
    let timeout;

    let isTransitioning = false;
    let queuedNavigation = null;

    const updateArrow = (index) => {
      prevArrow.disabled = index === 0;
      nextArrow.disabled = index === mediaLength - 1;
    };
    updateArrow(currentSlideIndex);

    // Drag state variables
    let isDragging = false;
    let startX = 0;
    let currentX = 0;
    let dragDistance = 0;
    let exceededThreshold = false;
    let direction = null; // 'left' or 'right'

    // Pause any playing videos when changing slides
    let sliderVideos = mediasSlider.querySelectorAll("video");
    const pauseAllVideos = () => {
      sliderVideos.forEach((video) => video.pause());
    };

    // Get the width of a single media item in percentage (cache to avoid forced reflow)
    let mediaWidthPercent;
    function updateMediaWidth() {
      // Use requestAnimationFrame to batch updates and avoid forced reflow
      requestAnimationFrame(() => {
        const sliderRect = mediasSlider.parentElement.getBoundingClientRect();
        const mediaRect = productMedias[0].getBoundingClientRect();
        mediaWidthPercent = (mediaRect.width / sliderRect.width) * 100;
      });
    }
    window.addEventListener("resize", updateMediaWidth, { passive: true });
    updateMediaWidth();

    // Calculate translateX value accounting for gaps (avoid forced reflow)
    function calculateTranslateX(index) {
      if (isMobile) {
        return `translateX(calc(-100% * ${index}))`;
      } else {
        // Cache container width to avoid forced reflow
        const containerWidth =
          mediasSlider.parentElement.getBoundingClientRect().width;
        const translateValue =
          index * (mediaWidthPercent + (mediaGap / containerWidth) * 100);
        return `translateX(calc(-${translateValue}%))`;
      }
    }

    // Update the mediasSlider style in updateSlider()
    function updateSlider(index) {
      mediasSlider.style.transition = `transform ${TRANSITION_DURATION}ms ease-out`;
      mediasSlider.style.transform = calculateTranslateX(index);
      updateArrow(index);
    }

    const updateBackground = (index) => {
      if (isMobile) return;

      const newMediaWrapper = productMedias[index];
      const background = document.querySelector(".product-page__background");

      background.querySelector("video, img")?.classList.add("fadeIn");

      setTimeout(() => {
        background.innerHTML = "";

        if (newMediaWrapper.dataset.mediaType === "video") {
          const videoContainer = document.createElement("div");
          videoContainer.className = "product-page__background-video";
          const video = newMediaWrapper.querySelector("video").cloneNode(true);
          video.setAttribute("autoplay", "true");
          video.setAttribute("loop", "true");
          video.setAttribute("muted", "true");
          video.removeAttribute("controls");
          videoContainer.appendChild(video);
          background.appendChild(videoContainer);
        } else {
          const imgElement = newMediaWrapper.querySelector("img");
          if (imgElement) {
            const img = document.createElement("img");
            img.className = "product-page__background-img";
            img.src = imgElement.src;
            img.alt = imgElement.alt;
            img.srcset = imgElement.srcset;
            img.sizes = imgElement.sizes;
            img.loading = "lazy";
            img.decoding = "async";
            background.appendChild(img);
          }
        }

        setTimeout(() => {
          background.querySelector("video, img")?.classList.remove("fadeIn");
        }, 16);
      }, 500);
    };

    // Update media fading during drag
    const updateMediaFadeDuringDrag = (distance) => {
      // Determine if we've exceeded threshold in either direction
      const newExceeded = Math.abs(distance) > DRAG_THRESHOLD;
      const newDirection = distance > 0 ? "right" : "left";

      // Only update if state changed
      if (newExceeded !== exceededThreshold || newDirection !== direction) {
        exceededThreshold = newExceeded;
        direction = newDirection;

        if (exceededThreshold) {
          // Apply fade to current slide if dragging left (next)
          if (direction === "left" && currentSlideIndex < mediaLength - 1) {
            productMedias[currentSlideIndex].classList.add("fadeOut");
          }
          // Apply fade to next slide if dragging right (previous)
          else if (direction === "right" && currentSlideIndex > 0) {
            productMedias[currentSlideIndex - 1].classList.remove("fadeOut");
          }
        } else {
          // Reset fade if we're back under threshold
          if (direction === "left") {
            productMedias[currentSlideIndex].classList.remove("fadeOut");
          } else if (direction === "right" && currentSlideIndex > 0) {
            productMedias[currentSlideIndex - 1].classList.add("fadeOut");
          }
        }
      }
    };

    const updateMediasFading = (index) => {
      productMedias.forEach((media, i) => {
        const isBefore = i < index;
        media.classList.toggle("fadeOut", isBefore);

        if (i < index) {
          media.setAttribute("tabindex", "-1"); // Prevent focus
        } else {
          media.removeAttribute("tabindex"); // Allow focus
          const video = media.querySelector("video");
          if (video) {
            video.currentTime = 0;
            if (i > index) video.pause();
            else video.play();
          }
        }
      });
      updateActiveBullet(index);
    };

    const updateActiveBullet = (index) => {
      sliderBullets.forEach((bullet, i) => {
        bullet.classList.toggle("active", i === index);
      });
    };

    // Unified pointer down handler
    const handlePointerDown = (e) => {
      isDragging = true;
      startX = getClientX(e);
      currentX = startX;
      dragDistance = 0;
      exceededThreshold = false;
      direction = null;
      slider.classList.add("dragging");
      mediasSlider.style.transition = "none";
    };

    // Unified pointer move handler
    const handlePointerMove = (e) => {
      if (!isDragging) return;

      const previousX = currentX;
      currentX = getClientX(e);
      dragDistance = currentX - startX;

      // Calculate the drag offset with resistance
      const offset = dragDistance * 0.5;

      // Apply the drag offset to the slider
      const currentTransform = parseTransform(mediasSlider.style.transform);
      mediasSlider.style.transform = `translateX(calc(${currentTransform}% + ${offset}px))`;

      // Update fade state during drag
      updateMediaFadeDuringDrag(dragDistance);
    };

    // Unified pointer up handler
    const handlePointerUp = (e) => {
      if (!isDragging) return;
      isDragging = false;
      slider.classList.remove("dragging");

      // Restore transition
      mediasSlider.style.transition = "transform 0.5s ease-out";

      // Check if drag distance exceeds threshold
      if (Math.abs(dragDistance) > DRAG_THRESHOLD) {
        if (dragDistance > 0 && currentSlideIndex > 0) {
          // Swipe right - previous slide
          goToSlide(currentSlideIndex - 1);
        } else if (dragDistance < 0 && currentSlideIndex < mediaLength - 1) {
          // Swipe left - next slide
          goToSlide(currentSlideIndex + 1);
        } else {
          // Return to current slide if at boundary
          updateSlider(currentSlideIndex);
          resetFadeState();
        }
      } else {
        // Return to current slide if threshold not met
        updateSlider(currentSlideIndex);
        resetFadeState();
      }

      // Reset drag state
      dragDistance = 0;
      exceededThreshold = false;
      direction = null;
    };

    // Reset fade state after drag ends
    const resetFadeState = () => {
      productMedias.forEach((media) => {
        const mediaIndex = parseInt(media.dataset.mediaIndex);
        if (mediaIndex < currentSlideIndex) {
          media.classList.add("fadeOut");
        } else {
          media.classList.remove("fadeOut");
        }
      });
    };

    // Helper function to parse transform value
    function parseTransform(transform) {
      if (!transform) return 0;
      const match = transform.match(/translateX\(calc\(([-\d.]+)%/);
      return match ? parseFloat(match[1]) : 0;
    }

    // Helper function to get the X position from different event types
    function getClientX(e) {
      return e.type.includes("touch") ? e.touches[0].clientX : e.clientX;
    }

    // Unified slide navigation function
    function goToSlide(index) {
      // If already transitioning, queue this navigation
      if (isTransitioning) {
        queuedNavigation = index;
        return;
      }

      clearTimeout(timeout);
      pauseAllVideos();
      currentSlideIndex = index;

      // Set transitioning flag
      isTransitioning = true;

      updateSlider(currentSlideIndex);

      // Delay the fade effects for consistency
      timeout = setTimeout(() => {
        updateMediasFading(currentSlideIndex);
        updateActiveBullet(currentSlideIndex);

        if (!isMobile) {
          updateBackground(currentSlideIndex);
        }

        // Transition complete
        isTransitioning = false;

        // Process any queued navigation
        if (queuedNavigation !== null) {
          const nextIndex = queuedNavigation;
          queuedNavigation = null;
          goToSlide(nextIndex);
        }
      }, FADE_DELAY);
    }

    // Navigation buttons handler

    // Update the handleNavigationArrows function
    const handleNavigationArrows = (e) => {
      if (isTransitioning) return;

      if (e.target.classList.contains("prev") && currentSlideIndex > 0) {
        goToSlide(currentSlideIndex - 1);
      }

      if (
        e.target.classList.contains("next") &&
        currentSlideIndex < mediaLength - 1
      ) {
        goToSlide(currentSlideIndex + 1);
      }
    };

    // Bullet navigation handler
    sliderBullets.forEach((bullet) => {
      bullet.addEventListener("click", function () {
        const slideIndex = parseInt(this.dataset.bulletSlide);
        goToSlide(slideIndex);
      });
    });

    // Event listeners
    slider.addEventListener("pointerdown", handlePointerDown);

    document.addEventListener("pointermove", handlePointerMove);
    document.addEventListener("pointerup", handlePointerUp);
    document.addEventListener("pointercancel", handlePointerUp);

    // Prevent default for mouse events to avoid text selection
    slider.addEventListener("dragstart", (e) => e.preventDefault());

    // Navigation buttons
    if (sliderBtns) {
      sliderBtns.addEventListener("click", handleNavigationArrows);
    }

    // Update video tag in main media to autoplay
    document.querySelectorAll(".product-video").forEach((video) => {
      video.setAttribute("autoplay", "true");
      video.setAttribute("loop", "true");
      video.setAttribute("muted", "true");
      video.removeAttribute("controls");
    });

    // Initialize first slide
    updateMediasFading(0);
    updateActiveBullet(0);
  }

  // Product form handling
  const productForm = document.getElementById("product-form");
  const productQuantity = productForm.querySelector('[name="quantity"]');
  const radios = productForm.querySelectorAll(
    ".product-page input[type='radio']"
  );
  const stockError = productForm.querySelector(".stock-error--pg");

  const setSelectedBundle = (e, radio) => {
    radios.forEach((radio) => {
      radio === e.target
        ? radio.setAttribute("checked", true)
        : radio.setAttribute("checked", false);
    });
    const quantity = e.target.dataset.quantity;
    productQuantity.value = quantity;
  };

  radios.forEach((radio) => {
    if (radio) {
      radio.addEventListener("click", setSelectedBundle);
    }
  });

  if (productForm) {
    let isFormSubmitting = false;
    
    productForm.addEventListener("submit", async function (e) {
      e.preventDefault();

      // Prevent form submission if buy now button was clicked
      const buyNowBtn = document.querySelector(".buy-now-btn");
      if (buyNowBtn && buyNowBtn.disabled && buyNowBtn.innerHTML.includes("Processing")) {
        return;
      }

      // Prevent multiple simultaneous submissions
      if (isFormSubmitting) {
        return;
      }

      const formData = new FormData(productForm);
      const submitBtn = productForm.querySelector('[type="submit"]');
      
      if (!submitBtn) {
        return;
      }
      
      const originalText = submitBtn.innerHTML;
      const formType = submitBtn.dataset.formType;

      isFormSubmitting = true;
      submitBtn.disabled = true;
      submitBtn.innerHTML = "Adding";

      try {
        // Normal add to cart flow (works for all form types including BOGO)
        const cartUrl = window.routes.cart_add_url + ".js";
        const response = await fetch(cartUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [
              { id: formData.get("id"), quantity: formData.get("quantity") },
            ],
          }),
        });

        const data = await response.json();

        if (response.ok) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            action: "add",
            variant: data,
            formData: Object.fromEntries(formData),
            product: productData,
          });
        } else {
          throw new Error(data.description || "Failed to add to cart");
        }
      } catch (error) {
        stockError.style.display = "block";
        setTimeout(() => {
          stockError.style.display = "none";
        }, 2000);
        console.error("Error:", error);
        publish(PUB_SUB_EVENTS.cartError, {
          error: error.message,
          context: "add-to-cart",
          productId: productData.id,
        });
      } finally {
        isFormSubmitting = false;
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
      }
    });
  }

  const quickAddElement = document.querySelector(".product-page-quick-add");
  const productPage = document.querySelector(".product-page");
  const header = document.getElementById("main-header");

  if (quickAddElement && productPage) {
    // Initially hide the quick add element
    quickAddElement.style.pointerEvents = "none";
    quickAddElement.style.opacity = "0";
    quickAddElement.style.transition =
      "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)";

    // Store last scroll position
    let lastScrollY = window.scrollY;
    let ticking = false;

    // Set initial top position
    const updateTopPosition = () => {
      quickAddElement.style.top = header.classList.contains("visible")
        ? "80px"
        : "1rem";
    };
    updateTopPosition();

    const handleScroll = () => {
      const scrollY = window.scrollY;
      const productPageRect = productPage.getBoundingClientRect();
      const productPageTop = productPageRect.top;
      const productPageBottom = productPageRect.bottom;
      const viewportHeight = window.innerHeight;

      // Calculate how much of the product page is visible
      const visibleThreshold = viewportHeight * 0.1; // 10% of viewport

      if (!ticking) {
        window.requestAnimationFrame(() => {
          // Show/hide based on product page visibility
          if (productPageBottom < visibleThreshold) {
            // Product page is leaving viewport - show quick add
            quickAddElement.style.opacity = "1";
            quickAddElement.style.pointerEvents = "auto";
            quickAddElement.style.transform = "translate(-50%, 0)";
          } else {
            // Product page is in viewport - hide quick add
            quickAddElement.style.pointerEvents = "none";
            quickAddElement.style.opacity = "0";
            quickAddElement.style.transform =
              "translate(-50%, calc(-110% - var(--header-height, 64px)))";
          }

          // Update top position based on header visibility
          updateTopPosition();

          lastScrollY = scrollY;
          ticking = false;
        });

        ticking = true;
      }
    };

    // Add scroll event listener with debouncing
    window.addEventListener("scroll", handleScroll, { passive: true });

    window.addEventListener("beforeunload", () =>
      window.removeEventListener("scroll", handleScroll)
    );

    // Also listen for header visibility changes
    const headerObserver = new MutationObserver(updateTopPosition);
    if (header) {
      headerObserver.observe(header, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }
  }

  // Buy now button - only add event listener if button exists
  const buyNowBtn = document.querySelector(".buy-now-btn");
  if (buyNowBtn) {
    let isProcessing = false;
    
    buyNowBtn.addEventListener("click", async function (e) {
      // Prevent form submission and event bubbling
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      // Prevent multiple simultaneous clicks
      if (isProcessing) {
        return;
      }
      
      const formType = buyNowBtn.dataset.formType;
      const formData = new FormData(productForm);
      const variantId = formData.get("id");
      
      // For BOGO, always use quantity 2, don't get from form
      const quantity = (formType === "2x (Buy 1 Get 1 Free)" && buyNowBtn.classList.contains("buy-now-bogo-btn")) 
        ? 2 
        : (formData.get("quantity") || 1);
      
      isProcessing = true;
      buyNowBtn.disabled = true;
      const originalText = buyNowBtn.innerHTML;
      buyNowBtn.innerHTML = "Processing...";
      
      try {
        // Handle BOGO (2x Buy 1 Get 1 Free) - clear cart, add 2 products, go to checkout
        if (formType === "2x (Buy 1 Get 1 Free)" && buyNowBtn.classList.contains("buy-now-bogo-btn")) {
          // Clear cart first - fetch cart and set all items to quantity 0
          const cartResponse = await fetch(window.routes.cart_url + ".js");
          const cartData = await cartResponse.json();

          if (cartData.items && cartData.items.length > 0) {
            const updates = {};
            cartData.items.forEach((item) => {
              updates[item.key] = 0;
            });

            const clearResponse = await fetch(
              window.routes.cart_update_url + ".js",
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ updates }),
              }
            );

            if (!clearResponse.ok) {
              throw new Error("Failed to clear cart");
            }
          }

          // Add exactly 2 products (hardcoded, not from form)
          const cartUrl = window.routes.cart_add_url + ".js";
          const response = await fetch(cartUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 2 }],
            }),
          });

          const data = await response.json();

          if (response.ok) {
            // Redirect to checkout
            window.location.href = "/checkout";
            return;
          } else {
            throw new Error(data.description || "Failed to add to cart");
          }
        } else {
          // Normal buy now flow - add to cart and redirect to checkout
          const cartUrl = window.routes.cart_add_url + ".js";
          const response = await fetch(cartUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: parseInt(quantity) }],
            }),
          });

          const data = await response.json();

          if (response.ok) {
            // Redirect to checkout
            window.location.href = "/checkout";
            return;
          } else {
            throw new Error(data.description || "Failed to add to cart");
          }
        }
      } catch (error) {
        console.error("Buy now error:", error);
        buyNowBtn.disabled = false;
        buyNowBtn.innerHTML = originalText;
        alert("An error occurred. Please try again.");
      } finally {
        isProcessing = false;
      }
    });
  }
});